import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Heading, Text, Button, Link } from '@chakra-ui/react';
import BackgroundImage from '../../components/shared/BackgroundImage';
import TwoColumns from '../../components/shared/TwoColumns';
import HeroImage from '../../images/lp-hero.webp';

const Hero = () => (
  <BackgroundImage imageUrl={HeroImage}>
    <TwoColumns
      minH="800px"
      maxColWidth="650px"
      col1={
        <Box color="white" mt="10">
          <Heading fontSize={['2xl', '3xl', '4xl', '5xl']}>
            Through the storm and beyond
          </Heading>
          <Text my="10" fontSize="24" fontWeight="b">
            Shaping the workflow for the modern restoration professional
          </Text>
          <Link
            href="https://calendly.com/hover-sdr/hover-for-restoration-contractors"
            target="_blank"
          >
            <Button size="lg">Connect with HOVER Today</Button>
          </Link>
        </Box>
      }
      col2={
        <StaticImage
          src="../../images/exterior-contractors-restoration-hero.png"
          alt="House with tree"
        />
      }
    />
  </BackgroundImage>
);

export default Hero;
